module.exports = ".applications-tiles .argo-table-list__row {\n  padding-top: 0;\n  padding-bottom: 0; }\n"